type SupabaseRuntimeEnv = {
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_PUBLISHABLE_KEY?: string;
  NEXT_PUBLIC_SUPABASE_URL?: string;
  NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY?: string;
};

type MetaElementLike = {
  getAttribute(name: string): string | null;
};

type DocumentLike = {
  querySelector(selector: string): MetaElementLike | null;
};

export const SUPABASE_RUNTIME_META = {
  url: "proptrust:supabase-url",
  publishableKey: "proptrust:supabase-publishable-key",
} as const;

export const embeddedSupabaseConfig = {
  url: "https://xuicaofitapirfgztcqp.supabase.co",
  key: "sb_publishable_MHz2TBb2CZeeQhzScN-IIA_R5fPh9oN",
} as const;

export function firstConfiguredValue(...values: Array<string | null | undefined>) {
  return values.map((value) => value?.trim()).find((value): value is string => Boolean(value));
}

export function readMetaContent(documentRef: DocumentLike | undefined, name: string) {
  return documentRef?.querySelector(`meta[name="${name}"]`)?.getAttribute("content")?.trim();
}

export function resolveSupabaseConfig(
  env: SupabaseRuntimeEnv,
  documentRef?: DocumentLike,
) {
  const url = firstConfiguredValue(
    env.VITE_SUPABASE_URL,
    env.NEXT_PUBLIC_SUPABASE_URL,
    readMetaContent(documentRef, SUPABASE_RUNTIME_META.url),
    embeddedSupabaseConfig.url,
  );
  const key = firstConfiguredValue(
    env.VITE_SUPABASE_PUBLISHABLE_KEY,
    env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
    readMetaContent(documentRef, SUPABASE_RUNTIME_META.publishableKey),
    embeddedSupabaseConfig.key,
  );

  if (!url || !key) {
    throw new Error("Missing Supabase environment variables: set VITE_SUPABASE_URL/VITE_SUPABASE_PUBLISHABLE_KEY or NEXT_PUBLIC_SUPABASE_URL/NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY.");
  }

  return { url, key };
}
